import { CheckIcon } from "@/components/ui/icon";
import { Checkbox, CheckboxIndicator, CheckboxIcon } from "@/components/ui/checkbox";
import { Pressable } from "@/components/ui/pressable";
import React from "react";
import BasicElement from "./BasicElement";
import { IconM } from "../media/IconsV2";

export default function ContactElement({ uri, title, text, onPress, id, selected, selected2 }) {

    // console.log('ContactElement', { uri, title, text, onPress, id, selected, selected2 });
    return (
        <Pressable onPress={() => selected == undefined && onPress && onPress(id, !selected)} className="px-3">
            <BasicElement
                media={uri}
                sync={'/contact/media/' + uri}
                title={title}
                text={text}
            >
                {onPress && <>
                    {selected == undefined ?
                        <IconM className={`text-primary-900 text-3xl self-end`} name='keyboard-arrow-right' />
                        :
                        <Checkbox key={selected + ' ' + selected2} size='lg' value={title} isChecked={selected || selected2} onChange={(e) => onPress(id, e)} aria-label={title} className="self-end active:border-primary-700">
                            <CheckboxIndicator className={` ${!selected && selected2 ? "border-secondary-400" : "border-primary-900"} mr-0 w-9 h-9 `}>
                                <CheckboxIcon as={CheckIcon} className={` ${!selected && selected2 ? "bg-secondary-400" : "bg-primary-900"} w-8 h-8 `} />
                            </CheckboxIndicator>
                        </Checkbox>
                    }
                </>}
            </BasicElement>
        </Pressable>
    );
}